import { ContainerModule } from '@patsnap/tahiti-core/shared/inversify';
import { ReportApiService } from '@/infrastructure/api-functions/report-api-service';
import { ReportApiServiceImpl } from '@/infrastructure/api-functions/report-api-service';
import { CustomService, CustomServiceImpl } from '@/services/report/custom-service';
import { IdeaSummaryService, IdeaSummaryServiceImpl } from '@/services/report/idea-summary-service';
import { CoreInnovationService, CoreInnovationServiceImpl } from '@/services/report/core-innovation-service';
import { MarketAnalysisService, MarketAnalysisServiceImpl } from '@/services/report/market-analysis-service';
import { TechSchemeService, TechSchemeServiceImpl } from '@/services/report/tech-scheme-service';
import { TechBgService, TechBgServiceImpl } from '@/services/report/tech-bg-service';
import { TechRoadmapService, TechRoadmapServiceImpl } from '@/services/report/tech-roadmap-service';
import { TechChallengeService, TechChallengeServiceImpl } from '@/services/report/tech-challenge-service';
import { HeadPlayerService, HeadPlayerServiceImpl } from '@/services/report/head-player-service';
import { TechSchemeApiService, TechSchemeApiServiceImpl } from '@/infrastructure/api-functions/tech-scheme-api-service';
import { CoreInnovationApiService, CoreInnovationApiServiceImpl } from '@/infrastructure/api-functions/core-innovation-api-service';

export const reportModule = new ContainerModule((bind) => {
    bind(ReportApiService).to(ReportApiServiceImpl);
    bind(TechSchemeApiService).to(TechSchemeApiServiceImpl);
    bind(CoreInnovationApiService).to(CoreInnovationApiServiceImpl);
    bind(CustomService).to(CustomServiceImpl).inRequestScope();
    bind(IdeaSummaryService).to(IdeaSummaryServiceImpl)
    bind(CoreInnovationService).to(CoreInnovationServiceImpl)
    bind(MarketAnalysisService).to(MarketAnalysisServiceImpl)
    bind(TechBgService).to(TechBgServiceImpl)
    bind(TechSchemeService).to(TechSchemeServiceImpl)
    bind(TechRoadmapService).to(TechRoadmapServiceImpl)
    bind(TechChallengeService).to(TechChallengeServiceImpl)
    bind(HeadPlayerService).to(HeadPlayerServiceImpl)
});
